import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";

function Dgi() {
  const cellStyle = {
    borderBottomColor: "black",
    borderBottomStyle: "solid",
    borderBottomWidth: 1,
  };
  const cellComplementStyle = {
    borderRightStyle: "solid",
    borderRightColor: "black",
    borderRightWidth: 1,
  };
  const materiasDocente = [
    {
      materia: "Gestión Integrada, Calidad, Medioambiente y Riesgos Laborales",
      horas: 140,
      docente: "M.Sc. Ing. Fatima Carola Laura Ayala",
    },
    {
      materia:
        "Sistemas de Gestion de la Calidad ISO 9000. Modelos de Autoevaluación.",
      horas: 140,
      docente: "Ing.M.Sc. Vigberto Frank Cespedes Saavedra",
    },
    {
      materia:
        "Sistemas de Gestion en Seguridad y Salud Ocupacional y la Norma ISO 45001.",
      horas: 140,
      docente: "Ph.D. Ing. Ahmed Ernesto Amusquivar Caballero",
    },
    {
      materia: "Sistemas de Gestión Medioambiental ISO 14000.",
      horas: 140,
      docente: "Ing. M.Sc. Jose Luis Quiroz Martinez",
    },
    {
      materia: "Gestión Integrada.",
      horas: 140,
      docente: "Ing. M.Sc. Martha Mendez Leclere",
    },
    {
      materia: "Auditorías Integradas.",
      horas: 140,
      docente: "Ing. M.Sc. Renzo del Carpio Jaldin",
    },

    {
      materia: "Asesoría y revisión de Tesinas",
      horas: 140,
      docente: "Ph. D. Ing. Tania Angela Teran Mita",
    },
  ];
  return (
    <TableContainer
      sx={{
        borderWidth: 1,
        borderStyle: "solid",
        borderRadius: 1,
        marginY: 2,
      }}
    >
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell
              align="center"
              sx={{
                ...cellStyle,
                ...cellComplementStyle,
              }}
            >
              <strong>MÓDULO</strong>
            </TableCell>
            <TableCell
              align="center"
              sx={{
                ...cellStyle,
                ...cellComplementStyle,
              }}
            >
              <strong>HORAS ACADÉMICAS</strong>
            </TableCell>
            <TableCell sx={cellStyle}>
              <strong>DOCENTES</strong>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {materiasDocente.map((item, index) => (
            <TableRow key={index}>
              <TableCell
                sx={{
                  ...cellStyle,
                  ...cellComplementStyle,
                }}
              >
                {item.materia}
              </TableCell>
              <TableCell
                sx={{
                  ...cellStyle,
                  ...cellComplementStyle,
                }}
                align="center"
              >
                {item.horas}
              </TableCell>
              <TableCell sx={{ ...cellStyle }}>{item.docente}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default Dgi;
